/* This is to standardize how categories of auto are dealt with */
export enum AutoCategoryType {
  Auto,
  Boat,
  Other
}
